<template>
    <div v-if="!showAlpha">
        <div v-for="(item, index) in items" :key="index">
            <div 
                class="services-landing__first-level-item"
                @click="setActive(item)"
            >
                <span>{{ item.title }}</span>
                <i v-if="item.children.length > 0 && active && active.url === item.url" class="icon-chevron-up"></i>
                <i v-if="item.children.length > 0 && (!active || active.url !== item.url)" class="icon-chevron-down"></i>
            </div>
            <div class="services-landing__second-level-wrapper" v-if="item.children.length > 0 && active   && active.url === item.url">
                <ServicesSecondLevel 
                    :items="item.children" 
                />
            </div>
        </div>
    </div>
    <div v-else>
        <div v-for="(item, index) in items" :key="index">
            <a class="services-landing__second-level-item services-landing__second-level-item--mobile" :href="item.url">
                {{ item.title }}
            </a>
        </div>
    </div>
</template>

<script>
import ServicesSecondLevel from "./ServicesSecondLevel.vue"

export default {
    props: ["items","showAlpha"],
    components: {
        ServicesSecondLevel
    },
    data() {
        return {
            active: null
        }
    },
    methods: {
        setActive: function (item) {
            if (item.children.length === 0) {
                window.location.href = item.url;
                return;
            }
            if (this.active && this.active.url === item.url) {
                this.active = null
            } else {
                this.active = item
            }
        }
    }

}
</script>

